import { classNames } from '@dimjs/utils';
import { hooks } from '@wove/react';
import { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { ModalDrawer } from '../../modal-drawer';
import { bodyAppendDivElement, BodyAppendDivElementProps, removeBodyChild } from '../../utils';
import './message-top.less';

interface DialogMessageTop {
  message: string;
  onClose?: () => void;
  duration?: number;
  showMask?: boolean;
  className?: string;
}

const ModalRender = (props: DialogMessageTop & BodyAppendDivElementProps) => {
  const { duration, elementId, ...otherProps } = props;
  const [visible, setVisible] = useState(false);
  const hasNtvFloat = location.search?.indexOf('ntv_float') >= 0;

  const onClose = hooks.useCallbackRef(() => {
    setVisible(false);
    props.onClose?.();
  });

  useEffect(() => {
    setVisible(true);
  }, []);

  const onAfterClose = hooks.useCallbackRef(() => {
    removeBodyChild(`#${elementId}`);
  });
  const onAfterOpen = hooks.useCallbackRef(() => {
    setTimeout(() => {
      onClose();
    }, duration || 2000);
  });

  const onMaskClick = hooks.useCallbackRef(() => {
    if (!props.onClose) {
      setVisible(false);
    }
  });

  const isFabricWebview = () => {
    return new RegExp('fabric@', 'i').test(navigator.userAgent.toLowerCase());
  };

  return (
    <ModalDrawer
      position="top"
      {...otherProps}
      visible={visible}
      getContainer={props.divElement}
      onClose={onClose}
      onAfterClose={onAfterClose}
      onAfterOpen={onAfterOpen}
      destroyOnClose={true}
      className={classNames(
        'v-dialog-message-top',
        { 'v-dialog-message-top-float': hasNtvFloat && isFabricWebview() },
        props.className,
      )}
      onMaskClick={onMaskClick}
      mask={props.showMask ? true : false}
    >
      <div className="v-dialog-message-top-body">
        <div className="v-dialog-message-top-body-content">{props.message}</div>
      </div>
    </ModalDrawer>
  );
};

export const dialogMessageTop = (props: string | DialogMessageTop) => {
  const { divElement, elementId } = bodyAppendDivElement();
  const newProps = typeof props === 'string' ? { message: props } : props;
  ReactDOM.render(<ModalRender {...newProps} divElement={divElement} elementId={elementId} />, divElement);

  // react 18
  // const root = createRoot(divElement);
  // root.render(<ModalRender {...newProps} divElement={divElement} elementId={elementId} />);
};
